"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillIcon = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_1 = __importDefault(require("react"));
//, size = 26, margin = 4, style = { marginLeft: 4 }
function PillIcon(props) {
    const { backgroundColor, iconColor, Icon, avatarUrl } = props;
    const iconProps = {
        size: 18,
        style: { margin: 4 },
        color: iconColor || lib_palette_1.default.White,
    };
    if (!Icon && !avatarUrl)
        return null;
    const mainStyles = {
        width: 26,
        height: 26,
        borderRadius: '50%',
        marginLeft: 4,
    };
    if (avatarUrl) {
        return react_1.default.createElement(core_1.Avatar, { src: avatarUrl, style: mainStyles });
    }
    if (!!backgroundColor) {
        return (react_1.default.createElement("div", { style: Object.assign(Object.assign({}, mainStyles), { backgroundColor: backgroundColor.main }) },
            react_1.default.createElement(Icon, Object.assign({}, iconProps))));
    }
    else {
        return react_1.default.createElement(Icon, Object.assign({}, iconProps));
    }
}
exports.PillIcon = PillIcon;
exports.default = PillIcon;
